(function () {
  /**
   * CTR Purchase Box V2
   * Product has 2 options: Format (Bag/Sticks) + Flavor (Mango/Raspberry)
   * Tiers are custom (defined in section settings):
   *   tier1 = 1 bag, tier2 = 2 bags, tier3 = 3 bags, buyone = 1 bag no selling plan
   * Each tier has its own sellingPlanId from settings.
   * bagFlavors[] tracks per-bag flavor selection.
   */
  function ctrPbv2Factory(sectionId) {
    var dataTag = document.getElementById('ctr-pbv2-data-' + sectionId);
    if (!dataTag) return {};

    var DATA = JSON.parse(dataTag.textContent);

    var FORMAT_OPTIONS = DATA.formatOptions || [];
    var FLAVOR_OPTIONS = DATA.flavorOptions || [];
    var PRODUCT_HANDLE = DATA.productHandle || '';
    var FLAVOR_IMAGE_INDEX = DATA.flavorImageIndex || {};
    var SYNC_MAIN_PRODUCT_VARIANT = DATA.syncMainProductVariant === true;
    var VARIANT_MAP    = DATA.variantMap || {};
    var TIER0          = DATA.tier0 || {};
    var TIER0_VARIANT_MAP = TIER0.variantMap || {};
    var TIER0_SELLING_PLAN = TIER0.sellingPlanId != null
      ? Number(TIER0.sellingPlanId)
      : 691417645345;
    var TIER0_FORMAT = TIER0.availableFormat || 'Sticks';
    var TIER0_LABEL = TIER0.label || '2 Weeks';
    var TIERS          = DATA.tiers || [];       // [{id,bagCount,label,badge,price,comparePrice,sellingPlanId,perks}]
    var SWATCH_COLORS  = DATA.swatchColors || {};
    var INVENTORY_LABELS = DATA.inventoryLabels || {};
    var ALL_VARIANTS   = DATA.allVariants || [];  // every variant with numeric servings + flavor + plan ids
    var BASE_SERVINGS  = DATA.baseServings || 28; // servings in one "bag" (tier N supply = BASE_SERVINGS × N)
    // How multi-month supply tiers add to cart (section setting "supply_cart_mode"):
    //   'dedicated' → add the single 56/84-serving SKU on the tier plan
    //   'packs'     → add one bag per selected flavor (×N), each on the tier plan (shoppers mix flavors)
    var SUPPLY_CART_MODE = DATA.supplyCartMode === 'packs' ? 'packs' : 'dedicated';
    // Opt-in emitted only by Unified for dedicated sized SKUs without Flavor.
    // Original CTR and Restore retain their existing flavor/pack behavior.
    var UNIFIED_SIZED_VARIANTS = DATA.unifiedSizedVariants === true;
    var STACK_GROUP = DATA.stackGroup || 'restore-bundle';
    // One flavor for the whole supply: every bag mirrors bag 1, and tier pricing
    // reads the dedicated 28/56/84-serving variant's own plan allocation.
    var SINGLE_FLAVOR = DATA.singleFlavorPerSupply === true && SUPPLY_CART_MODE === 'dedicated';

    function findDedicatedVariant(format, flavor, bagCount) {
      var target = BASE_SERVINGS * bagCount;
      return ALL_VARIANTS.find(function (v) {
        return v.format === format && v.flavor === flavor && Number(v.servings) === target;
      }) || null;
    }

    console.log('[ctr-pbv2] factory init BASE_SERVINGS=' + BASE_SERVINGS +
      ' FORMAT_OPTIONS=' + JSON.stringify(FORMAT_OPTIONS) +
      ' FLAVOR_OPTIONS=' + JSON.stringify(FLAVOR_OPTIONS));
    console.log('[ctr-pbv2] RAW TIERS = ' + JSON.stringify(TIERS.map(function (t) {
      return { id: t.id, bagCount: t.bagCount, sellingPlanId: t.sellingPlanId };
    })));
    console.log('[ctr-pbv2] RAW allVariants = ' + JSON.stringify(ALL_VARIANTS.map(function (v) {
      return { id: v.id, format: v.format, servings: v.servings, flavor: v.flavor };
    })));

    /* Build tier lookup by id */
    var TIER_BY_ID = {};
    TIERS.forEach(function(t) { TIER_BY_ID[t.id] = t; });

    // Explicit tier→selling-plan map straight from section settings (tier1/2/3_selling_plan_id).
    // Do NOT rely on the tiers[] lookup for the plan: on this template the reactive currentTier
    // lookup can hand back the wrong tier object, so we key the plan strictly off selectedTier.
    var TIER_PLANS = DATA.tierPlans || {};

    // Bag count for a given tier id ("tier2" → 2). Used to size the supply (servings = BASE × count)
    // instead of trusting tier.bagCount from a possibly-mismatched tier object.
    function tierBagCount(tierId) {
      var n = parseInt(String(tierId || '').replace(/\D/g, ''), 10);
      return (n && n > 0) ? n : 1;
    }
    console.log('[ctr-pbv2] TIER_PLANS = ' + JSON.stringify(TIER_PLANS) + ' SUPPLY_CART_MODE=' + SUPPLY_CART_MODE);

    var inventoryMethods = (window.ctrFlavorInventory && window.ctrFlavorInventory.createInventoryMethods)
      ? window.ctrFlavorInventory.createInventoryMethods({
          variantMap: VARIANT_MAP,
          getFormat: function() { return this.selectedFormat; },
          getSelectedFlavor: function() { return this.bagFlavors[0] || FLAVOR_OPTIONS[0] || ''; }
        })
      : {};

    function flavorAvailable(format, flavor) {
      if (window.ctrFlavorInventory && window.ctrFlavorInventory.getFlavorState) {
        return window.ctrFlavorInventory.getFlavorState({
          variantMap: VARIANT_MAP,
          flavor: flavor,
          format: format
        }).available;
      }
      return !!VARIANT_MAP[format + '|' + flavor];
    }

    function firstInStockFlavor(format) {
      return FLAVOR_OPTIONS.find(function(f) {
        return flavorAvailable(format, f);
      }) || FLAVOR_OPTIONS[0] || '';
    }

    // Preselect the configured tier (default 3 Months) when it has a selling plan; else the first tier.
    var initialTier = (function () {
      var wanted = TIER_BY_ID[DATA.defaultTier];
      if (wanted && wanted.sellingPlanId) return wanted.id;
      return TIERS[0] ? TIERS[0].id : 'tier1';
    })();

    var initialFormat = FORMAT_OPTIONS[0] || '';
    var initialFlavor = firstInStockFlavor(initialFormat);

    return Object.defineProperties(inventoryMethods, Object.getOwnPropertyDescriptors({
      /* ---- state ---- */
      selectedTier:   initialTier,
      selectedFormat: initialFormat,
      bagFlavors:     [initialFlavor, initialFlavor, initialFlavor],
      buyOnceQty:     1,
      buyOnceTierId:  TIERS[0] ? TIERS[0].id : 'tier1',
      isAdding:       false,
      isAddingUpsell: false,
      galleryIndex:   0,
      mobileStickyVisible: false,
      giftModalOpen:  false,
      upsellFlavors:  {},

      /* ---- exposed consts ---- */
      FORMAT_OPTIONS,
      FLAVOR_OPTIONS,
      VARIANT_MAP,
      TIERS,
      SWATCH_COLORS,
      inventoryLabels: INVENTORY_LABELS,

      /* ---- computed ---- */
      get currentTier() {
        var id = this.selectedTier;
        var t = TIER_BY_ID[id];
        // Defensive: if the map hands back a tier whose id doesn't match the
        // selection, resolve it directly from the array instead.
        if (!t || t.id !== id) {
          t = TIERS.find(function (x) { return x.id === id; }) || t || null;
        }
        return t || null;
      },

      get currentTierPrice() {
        if (this.selectedTier === 'buyone') return '';
        return this.getTierPrice(this.selectedTier);
      },

      get currentTierComparePrice() {
        if (this.selectedTier === 'buyone') return '';
        return this.getTierComparePrice(this.selectedTier);
      },

      /** CTA button price — for buyone uses variant price × qty, otherwise tier price */
      get ctaPrice() {
        if (this.selectedTier === 'buyone') {
          var v = this.getBuyOnceVariant();
          if (!v) return '';
          return this.formatMoney(v.price * this.buyOnceQty);
        }
        if (this.selectedTier === 'tier0') return this.getTier0Price();
        return this.currentTierPrice;
      },

      get ctaComparePrice() {
        if (this.selectedTier === 'buyone') {
          var v = this.getBuyOnceVariant();
          if (!v || !v.compareAtPrice || v.compareAtPrice <= v.price) return '';
          return this.formatMoney(v.compareAtPrice * this.buyOnceQty);
        }
        if (this.selectedTier === 'tier0') return this.getTier0ComparePrice();
        return this.currentTierComparePrice;
      },

      /** Total price for a tier, derived from its exact selling-plan allocation. */
      getTierPrice(tierId) {
        var tier = TIER_BY_ID[tierId];
        if (!tier) return '';
        return this._calcTierTotal(tier, 'price');
      },

      getTierComparePrice(tierId) {
        var tier = TIER_BY_ID[tierId];
        if (!tier) return '';
        var price = this._calcTierTotalCents(tier, 'price');
        var compare = this._calcTierTotalCents(tier, 'compareAt');
        return price !== null && compare !== null && compare > price ? this.formatMoney(compare) : '';
      },

      /** Badge text calculated from the tier's exact selling-plan allocation. */
      getTierBadge(tierId) {
        var tier = TIER_BY_ID[tierId];
        if (!tier) return '';
        if (tier.useCustomBadge && tier.badge) return tier.badge;
        if (!tier.sellingPlanId) return '';
        if (UNIFIED_SIZED_VARIANTS) {
          var totalPrice = this._calcTierTotalCents(tier, 'price');
          var totalCompare = this._calcTierTotalCents(tier, 'compareAt');
          if (totalPrice == null || !(totalCompare > totalPrice)) return '';
          return Math.round((1 - totalPrice / totalCompare) * 100) + '% OFF';
        }
        var flavor = this.bagFlavors[0] || FLAVOR_OPTIONS[0];
        var sp;
        if (SINGLE_FLAVOR) {
          var dv = findDedicatedVariant(this.selectedFormat, flavor, tier.bagCount);
          sp = dv && dv.planPrices ? dv.planPrices[String(tier.sellingPlanId)] : null;
        } else {
          var variant = this.getVariant(this.selectedFormat, flavor);
          if (!variant || !variant.sellingPlans) return '';
          sp = variant.sellingPlans[String(tier.sellingPlanId)];
        }
        var price = Number(sp?.price);
        var compare = Number(sp?.compareAt);
        if (!(compare > 0) || !(price >= 0) || price >= compare) return '';
        var pct = Math.round((1 - price / compare) * 100);
        return pct > 0 ? pct + '% OFF' : '';
      },

      /** Buy Once price — current variant price (no selling plan) */
      getBuyOncePrice() {
        var v = this.getBuyOnceVariant();
        if (!v) return '';
        return this.formatMoney(v.price);
      },

      getBuyOnceComparePrice() {
        var v = this.getBuyOnceVariant();
        if (!v || !v.compareAtPrice || v.compareAtPrice <= v.price) return '';
        return this.formatMoney(v.compareAtPrice);
      },

      /** Sum selling plan prices for all bags in a tier using current bagFlavors */
      _calcTierTotal(tier, field) {
        var cents = this._calcTierTotalCents(tier, field);
        return cents !== null ? this.formatMoney(cents) : '';
      },

      /** Returns raw cents total (or null if unavailable) */
      _calcTierTotalCents(tier, field) {
        if (!tier.sellingPlanId) return null;
        if (UNIFIED_SIZED_VARIANTS) {
          var sizedVariant = this.getSizedVariant(tier.id);
          var allocation = sizedVariant && sizedVariant.sellingPlanPrices
            && sizedVariant.sellingPlanPrices[String(tier.sellingPlanId)];
          var value = allocation && allocation[field];
          return value != null && Number.isFinite(Number(value)) ? Number(value) : null;
        }
        if (SINGLE_FLAVOR) {
          var dv = findDedicatedVariant(this.selectedFormat, this.bagFlavors[0] || FLAVOR_OPTIONS[0], tier.bagCount);
          var dsp = dv && dv.planPrices ? dv.planPrices[String(tier.sellingPlanId)] : null;
          return dsp ? (dsp[field] || 0) : null;
        }
        var total = 0;
        for (var i = 0; i < tier.bagCount; i++) {
          var flavor = this.bagFlavors[i] || this.bagFlavors[0] || FLAVOR_OPTIONS[0];
          var variant = this.getVariant(this.selectedFormat, flavor);
          if (!variant || !variant.sellingPlans) return null;
          var sp = variant.sellingPlans[String(tier.sellingPlanId)];
          if (!sp) return null;
          total += sp[field] || 0;
        }
        return total;
      },

      /** Price per month = total / bagCount */
      getTierPricePerMonth(tierId) {
        var tier = TIER_BY_ID[tierId];
        if (!tier || !tier.bagCount) return '';
        var cents = this._calcTierTotalCents(tier, 'price');
        if (cents === null) return '';
        return this.formatMoney(Math.round(cents / tier.bagCount));
      },

      /** Total price label: strikethrough compare + actual total */
      getTierTotalLabel(tierId) {
        var tier = TIER_BY_ID[tierId];
        if (!tier) return '';
        var price = this._calcTierTotalCents(tier, 'price');
        if (price === null) return '';
        return this.formatMoney(price) + ' total';
      },

      getTierCompareTotalLabel(tierId) {
        var tier = TIER_BY_ID[tierId];
        if (!tier) return '';
        var price = this._calcTierTotalCents(tier, 'price');
        var compare = this._calcTierTotalCents(tier, 'compareAt');
        if (price === null || compare === null || compare <= price) return '';
        return this.formatMoney(compare);
      },

      /** Presentation-only price rows used by the Unified WLP-style cards. */
      getUnifiedTierPricing(tierId) {
        var empty = { periodPrice: '', totalPrice: '', comparePrice: '', savings: '' };
        var price = null;
        var compare = null;
        var periods = 1;
        var quantity = 1;
        if (tierId === 'tier0') {
          var allocation = this.getTier0Allocation();
          if (!allocation || allocation.price == null) return empty;
          price = Number(allocation.price);
          compare = Number(allocation.compareAt);
        } else if (tierId === 'buyone') {
          var variant = this.getBuyOnceVariant();
          if (!variant || variant.price == null) return empty;
          price = Number(variant.price);
          compare = Number(variant.compareAtPrice);
          quantity = this.buyOnceQty;
        } else {
          var tier = TIER_BY_ID[tierId];
          if (!tier || !tier.bagCount) return empty;
          price = this._calcTierTotalCents(tier, 'price');
          compare = this._calcTierTotalCents(tier, 'compareAt');
          periods = tier.bagCount;
        }
        if (price == null || !Number.isFinite(price) || price < 0) return empty;
        var total = price * quantity;
        var compareTotal = compare * quantity;
        return {
          periodPrice: this.formatMoney(Math.round(price / periods)),
          totalPrice: this.formatMoney(total),
          comparePrice: compareTotal > total ? this.formatMoney(compareTotal) : '',
          savings: compareTotal > total ? this.formatMoney(compareTotal - total) : ''
        };
      },

      get currentAvailable() {
        if (UNIFIED_SIZED_VARIANTS) {
          if (this.selectedTier === 'buyone') return this.isBuyOnceSizeAvailable(this.buyOnceTierId);
          var sizedVariant = this.getSizedVariant(this.selectedTier);
          return this.isSizedVariantAvailable(sizedVariant)
            && this.currentTier != null
            && this._calcTierTotalCents(this.currentTier, 'price') != null;
        }
        var flavor = this.bagFlavors[0] || FLAVOR_OPTIONS[0];
        if (this.selectedTier === 'tier0') {
          return this.isTier0VariantAvailable(this.selectedFormat, flavor);
        }
        if (typeof this.isFlavorSoldOut === 'function') {
          return !this.isFlavorSoldOut(flavor, this.selectedFormat);
        }
        var v = this.getVariant(this.selectedFormat, flavor);
        return v ? v.available : false;
      },

      /* ---- helpers ---- */
      getSizedVariant(tierId) {
        if (!UNIFIED_SIZED_VARIANTS) return null;
        var tier = TIER_BY_ID[tierId];
        if (!tier) return null;
        var servings = Number(tier.servingSize) || BASE_SERVINGS * tier.bagCount;
        var format = this.selectedFormat;
        return ALL_VARIANTS.find(function (variant) {
          return variant.format === format && Number(variant.servings) === servings;
        }) || null;
      },

      isSizedVariantAvailable(variant) {
        if (!variant || variant.available === false) return false;
        if (window.ctrFlavorInventory && window.ctrFlavorInventory.getVariantState) {
          return window.ctrFlavorInventory.getVariantState(variant).available;
        }
        return !!variant.back_in_stock || !variant.sold_out;
      },

      getBuyOnceVariant() {
        if (UNIFIED_SIZED_VARIANTS) return this.getSizedVariant(this.buyOnceTierId);
        return this.getVariant(this.selectedFormat, this.bagFlavors[0] || FLAVOR_OPTIONS[0]);
      },

      isBuyOnceSizeAvailable(tierId) {
        return this.isSizedVariantAvailable(this.getSizedVariant(tierId));
      },

      selectBuyOnceSize(tierId) {
        if (!UNIFIED_SIZED_VARIANTS || !this.isBuyOnceSizeAvailable(tierId)) return;
        this.buyOnceTierId = tierId;
        this.emitMainProductVariant();
        this.emitStickyAtcState();
      },

      getVariant(format, flavor) {
        return VARIANT_MAP[format + '|' + flavor] || null;
      },

      /**
       * Resolve the single dedicated variant for a supply tier.
       * A tier's supply lives on its own variant (e.g. 2 Months = the 56-serving
       * variant), NOT the 28-serving variant bought in quantity. This picks the
       * variant whose servings match BASE_SERVINGS × bagCount, preferring the
       * selected flavor but accepting the only variant that exists for that size
       * (e.g. 56/84-serving are Mango-only). The tier's plan id is applied at add
       * time. Returns null only when no variant exists for that size, so the
       * caller can fall back to the legacy per-bag behavior.
       */
      resolveTierVariant(bagCount) {
        if (UNIFIED_SIZED_VARIANTS) return this.getSizedVariant('tier' + bagCount);
        console.log('[ctr-pbv2] resolveTierVariant() called', {
          bagCount: bagCount,
          selectedTier: this.selectedTier,
          selectedFormat: this.selectedFormat,
          bagFlavors: JSON.parse(JSON.stringify(this.bagFlavors)),
          BASE_SERVINGS: BASE_SERVINGS,
          allVariantsCount: ALL_VARIANTS.length,
          allVariants: ALL_VARIANTS
        });
        if (!bagCount || !ALL_VARIANTS.length) {
          console.warn('[ctr-pbv2] resolveTierVariant → null (missing bagCount/allVariants)');
          return null;
        }
        var target = BASE_SERVINGS * bagCount;
        var fmt = this.selectedFormat;

        /* The dedicated variant for a supply tier is identified by its servings
           size (BASE_SERVINGS × bagCount) — e.g. 2 Months = the 56-serving
           variant. We deliberately do NOT filter by the variant's
           selling_plan_allocations: Skio-managed plans often aren't exposed in
           Shopify's native Liquid allocations, so the tier's plan id from the
           section settings is applied directly at add time (same approach as the
           launch/lander pages). Flavor must match — some sizes exist in a single
           flavor only (e.g. 56/84-serving are Mango-only), so other flavors fall
           back to the per-bag add. */
        var candidates = ALL_VARIANTS.filter(function (v) {
          return v.format === fmt && Number(v.servings) === target;
        });
        console.log('[ctr-pbv2] resolveTierVariant candidates', {
          targetServings: target,
          format: fmt,
          matchCount: candidates.length,
          candidates: candidates
        });
        if (!candidates.length) {
          console.warn('[ctr-pbv2] resolveTierVariant → null (no variant matches format="' + fmt + '" + servings=' + target + '). Falling back to legacy per-bag add.');
          return null;
        }

        /* Match flavors by leading token so naming differences don't matter
           ("Raspberry" ↔ "All Raspberry", "Mango" ↔ "Mango Lemonade"). */
        var tokenOf = function (f) { return String(f || '').toLowerCase().split(' ')[0]; };
        var flavorsIn = function (label) {
          var l = String(label || '').toLowerCase();
          return FLAVOR_OPTIONS.filter(function (f) { return l.indexOf(tokenOf(f)) !== -1; })
            .map(function (f) { return tokenOf(f); });
        };
        var sameSet = function (a, b) {
          if (a.length !== b.length) return false;
          return a.every(function (x) { return b.indexOf(x) !== -1; });
        };
        var inStock = function (v) { return v.available !== false && !v.sold_out; };

        /* Flavors requested across this tier's bags (deduped by token). */
        var wanted = [];
        for (var i = 0; i < bagCount; i++) {
          var t = tokenOf(this.bagFlavors[i] || this.bagFlavors[0] || FLAVOR_OPTIONS[0]);
          if (wanted.indexOf(t) === -1) wanted.push(t);
        }
        var primaryToken = tokenOf(this.bagFlavors[0] || FLAVOR_OPTIONS[0]);

        /* Exact flavor-set only (all-same or a "Mix" combo), preferring an
           in-stock variant. */
        var pick = function (test) {
          return candidates.find(function (v) { return test(v) && inStock(v); })
            || candidates.find(test);
        };

        var resolved = pick(function (v) { return sameSet(flavorsIn(v.flavor), wanted); })
          || null;
        console.log('[ctr-pbv2] resolveTierVariant → resolved variant', {
          wantedFlavors: wanted,
          primaryToken: primaryToken,
          resolved: resolved
        });
        return resolved;
      },

      isVariantAvailable(format, flavor) {
        var v = this.getVariant(format, flavor);
        if (!v) return false;
        if (typeof this.isFlavorSoldOut === 'function') {
          return !this.isFlavorSoldOut(flavor, format);
        }
        return v.available;
      },

      hasFlavorForFormat(format, flavor) {
        if (typeof this.hasFlavorVariant === 'function') {
          return this.hasFlavorVariant(flavor, format);
        }
        return !!this.getVariant(format, flavor);
      },

      swatchColor(flavor) {
        return SWATCH_COLORS[(flavor || '').toLowerCase()] || 'transparent';
      },

      formatMoney(cents) {
        if (typeof window.utils?.formatMoney === 'function') {
          return window.utils.formatMoney(cents);
        }
        return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
      },

      getStickyAtcState() {
        var flavor = this.bagFlavors[0] || FLAVOR_OPTIONS[0] || '';
        var variant = null;
        var sellingPlanId = null;
        var sellingPlanName = '';

        if (UNIFIED_SIZED_VARIANTS) {
          variant = this.selectedTier === 'buyone'
            ? this.getBuyOnceVariant() : this.getSizedVariant(this.selectedTier);
          if (this.selectedTier !== 'buyone') {
            sellingPlanId = TIER_PLANS[this.selectedTier] || this.currentTier?.sellingPlanId || null;
            sellingPlanName = this.currentTier?.label || '';
          }
        } else if (this.selectedTier === 'tier0') {
          variant = this.getTier0Variant(this.selectedFormat, flavor);
          sellingPlanId = TIER0_SELLING_PLAN;
          sellingPlanName = TIER0_LABEL;
        } else {
          variant = this.getVariant(this.selectedFormat, flavor);
          if (SINGLE_FLAVOR && this.selectedTier !== 'buyone') {
            variant = findDedicatedVariant(this.selectedFormat, flavor, tierBagCount(this.selectedTier)) || variant;
          }
          if (this.selectedTier !== 'buyone') {
            sellingPlanId = TIER_PLANS[this.selectedTier]
              || this.currentTier?.sellingPlanId
              || null;
            sellingPlanName = this.currentTier?.label || '';
          }
        }

        if (SYNC_MAIN_PRODUCT_VARIANT) variant = this.getMainProductSelection().variant;

        var state = {
          productHandle: PRODUCT_HANDLE,
          variantId: variant?.id || null,
          sellingPlanId: sellingPlanId || null,
          sellingPlanName: sellingPlanName || ''
        };
        if (SYNC_MAIN_PRODUCT_VARIANT) {
          state.unified = true;
          state.format = this.selectedFormat;
          // Preserve the original short tier's Monthly sticky wording.
          state.supplyMonths = this.selectedTier === 'tier0' ? 1 : Number(TIER_BY_ID[this.selectedTier]?.bagCount) || 1;
        }
        return state;
      },

      emitStickyAtcState() {
        var state = this.getStickyAtcState();
        if (!state.productHandle || !state.variantId) return;
        document.dispatchEvent(new CustomEvent('ctr-pbv2:state-change', {
          detail: state
        }));
      },

      getTier0Variant(format, flavor) {
        return TIER0_VARIANT_MAP[format + '|' + flavor] || null;
      },

      getTier0Allocation() {
        var flavor = this.bagFlavors[0] || FLAVOR_OPTIONS[0];
        var variant = this.getTier0Variant(this.selectedFormat, flavor);
        if (!variant || !variant.sellingPlans || !TIER0_SELLING_PLAN) return null;
        return variant.sellingPlans[String(TIER0_SELLING_PLAN)] || null;
      },

      getTier0Price() {
        var allocation = this.getTier0Allocation();
        var price = Number(allocation?.price);
        return price >= 0 ? this.formatMoney(price) : '';
      },

      getTier0ComparePrice() {
        var allocation = this.getTier0Allocation();
        if (!allocation || !allocation.compareAt || allocation.compareAt <= allocation.price) return '';
        return this.formatMoney(allocation.compareAt);
      },

      getTier0Badge() {
        var allocation = this.getTier0Allocation();
        var price = Number(allocation?.price);
        var compare = Number(allocation?.compareAt);
        if (!(compare > 0) || !(price >= 0) || price >= compare) return '';
        var pct = Math.round((1 - price / compare) * 100);
        return pct > 0 ? pct + '% OFF' : '';
      },

      _getTier0FlavorState(flavor, format) {
        if (window.ctrFlavorInventory && window.ctrFlavorInventory.getFlavorState) {
          return window.ctrFlavorInventory.getFlavorState({
            variantMap: TIER0_VARIANT_MAP,
            flavor: flavor,
            format: format != null ? format : this.selectedFormat
          });
        }
        var variant = this.getTier0Variant(format != null ? format : this.selectedFormat, flavor);
        var backInStock = !!(variant && variant.back_in_stock);
        var soldOut = !backInStock && !!(variant && variant.sold_out);
        return {
          available: variant ? !soldOut : false,
          soldOut: soldOut,
          lowStock: !!(variant && variant.low_stock && !soldOut && !backInStock),
          backInStock: backInStock
        };
      },

      hasTier0FlavorForFormat(format, flavor) {
        return !!this.getTier0Variant(format, flavor);
      },

      isTier0VariantAvailable(format, flavor) {
        var v = this.getTier0Variant(format, flavor);
        if (!v) return false;
        return !this._getTier0FlavorState(flavor, format).soldOut;
      },

      showTier0SoldOutBadge(flavor, format) {
        return this._getTier0FlavorState(flavor, format).soldOut;
      },

      showTier0BackInStockBadge(flavor, format) {
        return !!this._getTier0FlavorState(flavor, format).backInStock;
      },

      isTier0FlavorLowStock(flavor, format) {
        var state = this._getTier0FlavorState(flavor, format);
        if (state.soldOut) return false;
        return state.lowStock;
      },

      /* ---- actions ---- */
      selectTier(tierId) {
        if (UNIFIED_SIZED_VARIANTS && TIER_BY_ID[tierId]) this.buyOnceTierId = tierId;
        this.selectedTier = tierId;
        if (tierId === 'tier0') {
          var fmt = this.selectedFormat;
          var current = this.bagFlavors[0] || FLAVOR_OPTIONS[0];
          if (!this.isTier0VariantAvailable(fmt, current)) {
            var first = FLAVOR_OPTIONS.find(function(f) {
              return this.isTier0VariantAvailable(fmt, f);
            }.bind(this)) || FLAVOR_OPTIONS[0] || '';
            this.bagFlavors = [first, first, first];
          }
        }
        this.emitMainProductVariant();
      },

      selectFormat(format) {
        this.selectedFormat = format;
        // Reset to tier1 if leaving the format assigned to the optional short tier.
        if (format !== TIER0_FORMAT && this.selectedTier === 'tier0') {
          this.selectedTier = TIERS[0] ? TIERS[0].id : 'tier1';
        }
        if (this.selectedTier === 'tier0' && format === TIER0_FORMAT) {
          var firstTier0 = FLAVOR_OPTIONS.find(function(f) {
            return this.isTier0VariantAvailable(format, f);
          }.bind(this)) || FLAVOR_OPTIONS[0] || '';
          this.bagFlavors = this.bagFlavors.map(function(f) {
            return this.isTier0VariantAvailable(format, f) ? f : firstTier0;
          }.bind(this));
        } else {
          var firstAvailable = firstInStockFlavor(format);
          this.bagFlavors = this.bagFlavors.map(function(f) {
            return flavorAvailable(format, f) ? f : firstAvailable;
          });
        }
        this.emitMainProductVariant();
      },

      setBagFlavor(bagIndex, flavor) {
        if (this.selectedTier === 'tier0') {
          if (!this.isTier0VariantAvailable(this.selectedFormat, flavor)) return;
        } else {
          if (!this.hasFlavorForFormat(this.selectedFormat, flavor)) return;
          if (this.isFlavorSoldOut && this.isFlavorSoldOut(flavor, this.selectedFormat)) return;
        }
        var next = this.bagFlavors.slice();
        next[bagIndex] = flavor;
        if (SINGLE_FLAVOR) next = next.map(function () { return flavor; });
        this.bagFlavors = next;
        var imgIdx = FLAVOR_IMAGE_INDEX[flavor];
        if (typeof imgIdx === 'number') {
          this.galleryIndex = imgIdx;
          if (typeof this.scrollMobileGallery === 'function' && this.$refs && this.$refs.mobileGallery) {
            this.scrollMobileGallery(imgIdx);
          }
        }
        this.emitMainProductVariant(flavor);
      },

      setAllBagFlavors(flavor) {
        if (this.selectedTier === 'tier0') {
          if (!this.isTier0VariantAvailable(this.selectedFormat, flavor)) return;
        } else {
          if (!this.hasFlavorForFormat(this.selectedFormat, flavor)) return;
          if (this.isFlavorSoldOut && this.isFlavorSoldOut(flavor, this.selectedFormat)) return;
        }
        this.bagFlavors = [flavor, flavor, flavor];
        this.emitMainProductVariant(flavor);
      },

      getMainProductSelection(flavorOverride) {
        var flavor = flavorOverride || this.bagFlavors[0] || FLAVOR_OPTIONS[0];
        var baseVariant = this.selectedTier === 'tier0'
          ? this.getTier0Variant(this.selectedFormat, flavor)
          : this.getVariant(this.selectedFormat, flavor);
        var variant = baseVariant;
        if (UNIFIED_SIZED_VARIANTS) {
          variant = this.selectedTier === 'buyone'
            ? this.getBuyOnceVariant() : this.getSizedVariant(this.selectedTier);
        }
        // Unified's main gallery must follow the actual sized SKU for a dedicated
        // supply tier, not always the base-size SKU. Keep the pack/Buy Once paths
        // and missing-size fallback on the base variant, as in addToCart().
        if (!UNIFIED_SIZED_VARIANTS && SUPPLY_CART_MODE === 'dedicated' && this.selectedTier !== 'tier0' && this.selectedTier !== 'buyone') {
          var bagCount = tierBagCount(this.selectedTier);
          if (bagCount > 1) {
            variant = this.resolveTierVariant(bagCount) || baseVariant;
          }
        }
        return {
          variant: variant,
          mediaId: variant?.featuredMediaId || baseVariant?.featuredMediaId || null
        };
      },

      emitMainProductVariant(flavorOverride) {
        if (!SYNC_MAIN_PRODUCT_VARIANT || !this.$root) return;
        var selection = this.getMainProductSelection(flavorOverride);
        var variant = selection.variant;
        if (!variant || !variant.id) return;
        var mediaId = selection.mediaId;
        this.$root.dispatchEvent(new CustomEvent('unified-pbv2:variant-change', {
          bubbles: true,
          detail: {
            variantId: Number(variant.id),
            mediaId: mediaId ? Number(mediaId) : null
          }
        }));
      },

      adjustQty(delta) {
        this.buyOnceQty = Math.max(1, this.buyOnceQty + delta);
      },

      scrollThumbs(dir) {
        var el = this.$refs.thumbsTrack;
        if (el) el.scrollBy({ top: dir * 80, behavior: 'smooth' });
      },

      /* ---- Gallery ---- */
      onMobileGalleryScroll(el) {
        var slides = el.querySelectorAll('.ctr-pbv2__gallery-mobile-slide');
        if (!slides.length) return;
        var slideWidth = slides[0].offsetWidth + 12;
        var index = Math.min(Math.round(el.scrollLeft / slideWidth), slides.length - 1);
        if (index !== this.galleryIndex) this.galleryIndex = index;
      },

      scrollMobileGallery(index) {
        var el = this.$refs.mobileGallery;
        if (!el) return;
        var slides = el.querySelectorAll('.ctr-pbv2__gallery-mobile-slide');
        if (!slides[index]) return;
        el.scrollTo({ left: slides[index].offsetLeft - 20, behavior: 'smooth' });
        this.galleryIndex = index;
      },

      /* ---- Add to Cart ---- */
      async addToCart(options) {
        if (this.isAdding) return;
        if (UNIFIED_SIZED_VARIANTS && !this.currentAvailable) return;

        options = options || {};
        var closeQuickView = function() {
          if (!options.closeQuickView) return;
          var quickView = window._stores?.quickView;
          if (typeof quickView?.closeQuickView === 'function') quickView.closeQuickView();
          else if (quickView) quickView.show = false;
        };

        var _ct = this.currentTier;
        console.log('[ctr-pbv2] addToCart() START selectedTier=' + this.selectedTier +
          ' selectedFormat=' + this.selectedFormat +
          ' currentTier=' + JSON.stringify(_ct ? { id: _ct.id, bagCount: _ct.bagCount, sellingPlanId: _ct.sellingPlanId } : null) +
          ' bagFlavors=' + JSON.stringify(this.bagFlavors));

        var items = [];

        if (this.selectedTier === 'buyone') {
          var v = this.getBuyOnceVariant();
          if (!v) return;
          items.push({ id: v.id, quantity: this.buyOnceQty });
        } else if (this.selectedTier === 'tier0') {
          var tier0Flavor = this.bagFlavors[0] || FLAVOR_OPTIONS[0];
          var tier0Variant = this.getTier0Variant(this.selectedFormat, tier0Flavor);
          if (!tier0Variant) return;
          items.push({
            id: tier0Variant.id,
            quantity: 1,
            selling_plan: TIER0_SELLING_PLAN
          });
        } else {
          /* Derive everything from the selected tier id — NOT from currentTier,
             whose lookup can return the wrong tier object on this template (it was
             handing back tier1 for tier2/tier3, so every supply added the 1-month
             variant on the 1-month plan). bagCount comes from the id ("tier2" → 2)
             and the plan comes from the explicit TIER_PLANS map keyed by tier id. */
          var tierId = this.selectedTier;
          var bagCount = tierBagCount(tierId);
          var planId = TIER_PLANS[tierId]
            || (this.currentTier && this.currentTier.sellingPlanId)
            || null;
          console.log('[ctr-pbv2] addToCart TIER resolve', {
            tierId: tierId,
            bagCount: bagCount,
            planId: planId,
            supplyCartMode: SUPPLY_CART_MODE,
            targetServings: BASE_SERVINGS * bagCount
          });

          /* Dedicated-variant mode: each supply tier is its own SKU (e.g. "2 Months"
             = the 56-serving / 2-bag variant) added once on the tier's plan. No
             _stack_group here, so the quantity-based retier leaves it alone. Used
             when a selected flavor has no multi-bag SKU (e.g. Raspberry OOS). Only
             attempted when the setting asks for it. */
          var dedicated = SUPPLY_CART_MODE === 'dedicated' ? this.resolveTierVariant(bagCount) : null;
          if (dedicated) {
            var dItem = { id: dedicated.id, quantity: 1 };
            if (planId) dItem.selling_plan = planId;
            items.push(dItem);
            console.log('[ctr-pbv2] addToCart DEDICATED path', {
              variantId: dItem.id,
              sellingPlan: dItem.selling_plan,
              dedicatedVariant: dedicated
            });
          } else {
            /* Individual-packs mode (or dedicated fallback when no SKU exists):
               add one bag per selected flavor so shoppers can mix flavors, each on
               the tier's selling plan. Tagged with _stack_group so the retier can
               normalize the plan by total bag count. */
            console.log('[ctr-pbv2] addToCart PACKS per-bag path for ' + bagCount + '-bag supply (mode=' + SUPPLY_CART_MODE + ')');
            for (var i = 0; i < bagCount; i++) {
              var bagFlavor = this.bagFlavors[i] || this.bagFlavors[0] || FLAVOR_OPTIONS[0];
              var variant = this.getVariant(this.selectedFormat, bagFlavor);
              if (!variant) continue;
              var item = { id: variant.id, quantity: 1, properties: { _stack_group: STACK_GROUP } };
              if (planId) item.selling_plan = planId;
              items.push(item);
            }
          }
        }

        console.log('[ctr-pbv2] addToCart FINAL payload sent to cart', {
          items: JSON.parse(JSON.stringify(items)),
          usingCartStore: typeof window._cart?.add === 'function'
        });

        if (!items.length) return;
        this.isAdding = true;

        try {
          if (typeof window._cart?.add === 'function') {
            var data = await window._cart.add({ items });
            console.log('[ctr-pbv2] _cart.add() response — cart line items now:',
              (data?.items || []).map(function (li) {
                return {
                  title: li.title,
                  variant_id: li.variant_id || li.id,
                  quantity: li.quantity,
                  selling_plan: li.selling_plan_allocation && li.selling_plan_allocation.selling_plan
                    ? { id: li.selling_plan_allocation.selling_plan.id, name: li.selling_plan_allocation.selling_plan.name }
                    : null,
                  properties: li.properties
                };
              })
            );
            if (data?.cart_error) console.error('[ctr-pbv2] _cart.add reported cart_error', data);
            if (!data?.cart_error && typeof window._stores?.modal?.setId === 'function') {
              window._stores.modal.setId('modal--cart-drawer');
            }
            if (!data?.cart_error) closeQuickView();
          } else {
            var response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: JSON.stringify({ items })
            });
            var addJson = await response.clone().json().catch(function () { return null; });
            console.log('[ctr-pbv2] /cart/add.js response', { ok: response.ok, status: response.status, body: addJson });
            if (!response.ok) throw new Error('Cart error');
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            var drawer = document.querySelector('[data-cart-drawer], cart-drawer, #CartDrawer');
            if (drawer?.open) drawer.open();
            else if (typeof window.theme?.openCartDrawer === 'function') window.theme.openCartDrawer();
            else window.location.href = '/cart';
            closeQuickView();
          }
        } catch (err) {
          console.error('[ctr-pbv2] Cart add failed:', err);
        } finally {
          this.isAdding = false;
        }
      },

      /* ---- Upsell ---- */
      _getUpsellFlavorState(blockId, flavor) {
        var data = this.getUpsellData(blockId);
        if (window.ctrFlavorInventory && window.ctrFlavorInventory.getFlavorState) {
          return window.ctrFlavorInventory.getFlavorState({
            variantMap: data.variantMap || {},
            flavor: flavor
          });
        }
        var variant = (data.variantMap || {})[flavor];
        var backInStock = !!(variant && variant.back_in_stock);
        var soldOut = !backInStock && !!(variant && variant.sold_out);
        return {
          available: variant ? !soldOut : false,
          soldOut: soldOut,
          lowStock: !!(variant && variant.low_stock && !soldOut && !backInStock),
          backInStock: backInStock
        };
      },

      getUpsellFlavor(blockId, defaultFlavor) {
        if (this.upsellFlavors[blockId]) return this.upsellFlavors[blockId];
        return this.firstInStockUpsellFlavor(blockId) || defaultFlavor || '';
      },

      firstInStockUpsellFlavor(blockId) {
        var data = this.getUpsellData(blockId);
        var self = this;
        return (data.flavorOptions || []).find(function(f) {
          return self.isUpsellFlavorAvailable(blockId, f);
        }) || '';
      },

      isUpsellFlavorSoldOut(blockId, flavor) {
        return this._getUpsellFlavorState(blockId, flavor).soldOut;
      },

      showUpsellSoldOutBadge(blockId, flavor) {
        return this.isUpsellFlavorSoldOut(blockId, flavor);
      },

      showUpsellBackInStockBadge(blockId, flavor) {
        return !!this._getUpsellFlavorState(blockId, flavor).backInStock;
      },

      isUpsellFlavorLowStock(blockId, flavor) {
        if (this.isUpsellFlavorSoldOut(blockId, flavor)) return false;
        return this._getUpsellFlavorState(blockId, flavor).lowStock;
      },

      isUpsellFlavorAvailable(blockId, flavor) {
        return this._getUpsellFlavorState(blockId, flavor).available;
      },

      isSelectedUpsellFlavorSoldOut(blockId, defaultFlavor) {
        return this.isUpsellFlavorSoldOut(blockId, this.getUpsellFlavor(blockId, defaultFlavor));
      },

      setUpsellFlavor(blockId, flavor) {
        if (!this.isUpsellFlavorAvailable(blockId, flavor)) return;
        this.upsellFlavors = Object.assign({}, this.upsellFlavors, { [blockId]: flavor });
      },

      getUpsellData(blockId) {
        var tag = document.getElementById('ctr-pbv2-upsell-' + blockId);
        if (!tag) return { flavorOptions: [], variantMap: {} };
        try { return JSON.parse(tag.textContent); } catch(e) { return { flavorOptions: [], variantMap: {} }; }
      },

      getUpsellVariant(blockId, defaultFlavor) {
        var data = this.getUpsellData(blockId);
        var flavor = this.getUpsellFlavor(blockId, defaultFlavor || (data.flavorOptions || [])[0] || '');
        return (data.variantMap || {})[flavor] || null;
      },

      /** Pricing for the exact two-line payload used by addUpsellToCart. */
      getUpsellCombinedPricing(blockId, defaultFlavor) {
        var mainVariant = this.getVariant(this.selectedFormat, this.bagFlavors[0] || FLAVOR_OPTIONS[0]);
        var upsellVariant = this.getUpsellVariant(blockId, defaultFlavor);
        if (upsellVariant && upsellVariant.sellingPlanId) {
          var planCompare = upsellVariant.planCompareAt || upsellVariant.price;
          var planDiscount = planCompare > upsellVariant.planPrice
            ? Math.round((1 - upsellVariant.planPrice / planCompare) * 100)
            : 0;
          return { price: upsellVariant.planPrice, compare: planCompare, discount: planDiscount };
        }
        if (!mainVariant || !upsellVariant || !mainVariant.price || !upsellVariant.price) return null;

        var mainPrice = mainVariant.price;
        var mainCompare = mainVariant.price;
        var hasValidAllocation = false;
        var tier = this.currentTier;

        // This mirrors addUpsellToCart: only tiers 1–3 add a selling plan.
        if (tier && tier.sellingPlanId && this.selectedTier !== 'buyone') {
          var allocation = mainVariant.sellingPlans?.[String(tier.sellingPlanId)];
          var allocationPrice = Number(allocation?.price);
          if (allocation && allocationPrice >= 0) {
            mainPrice = allocationPrice;
            mainCompare = allocation.compareAt || mainVariant.price;
            hasValidAllocation = mainCompare > mainPrice;
          }
        }

        var upsellCompare = Math.max(upsellVariant.compareAtPrice || 0, upsellVariant.price);
        var price = mainPrice + upsellVariant.price;
        var compare = mainCompare + upsellCompare;
        var discount = hasValidAllocation && compare > price
          ? Math.round((1 - price / compare) * 100)
          : 0;

        return { price: price, compare: compare, discount: discount };
      },

      getUpsellCombinedPrice(blockId, defaultFlavor) {
        var pricing = this.getUpsellCombinedPricing(blockId, defaultFlavor);
        return pricing ? this.formatMoney(pricing.price) : '';
      },

      getUpsellCombinedComparePrice(blockId, defaultFlavor) {
        var pricing = this.getUpsellCombinedPricing(blockId, defaultFlavor);
        return pricing && pricing.discount > 0 ? this.formatMoney(pricing.compare) : '';
      },

      getUpsellCombinedBadge(blockId, defaultFlavor) {
        var pricing = this.getUpsellCombinedPricing(blockId, defaultFlavor);
        return pricing && pricing.discount > 0 ? pricing.discount + '% OFF' : '';
      },

      async addUpsellToCart(blockId, defaultFlavor) {
        if (this.isAddingUpsell) return;
        if (this.isSelectedUpsellFlavorSoldOut(blockId, defaultFlavor)) return;
        var mainVariant = this.getVariant(this.selectedFormat, this.bagFlavors[0] || FLAVOR_OPTIONS[0]);
        var upsellVariant = this.getUpsellVariant(blockId, defaultFlavor);
        if (!mainVariant || !upsellVariant) return;

        this.isAddingUpsell = true;
        try {
          /* Add main product (1 bag, tier1 selling plan or no plan) */
          var tier = this.currentTier;
          var mainItem = { id: mainVariant.id, quantity: 1 };
          if (tier && tier.sellingPlanId && this.selectedTier !== 'buyone') {
            mainItem.selling_plan = tier.sellingPlanId;
          }
          var items = upsellVariant.sellingPlanId
            ? [{ id: upsellVariant.id, quantity: 1, selling_plan: upsellVariant.sellingPlanId }]
            : [mainItem, { id: upsellVariant.id, quantity: 1 }];

          if (typeof window._cart?.add === 'function') {
            var data = await window._cart.add({ items });
            if (!data?.cart_error && typeof window._stores?.modal?.setId === 'function') {
              window._stores.modal.setId('modal--cart-drawer');
            }
          } else {
            var response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: JSON.stringify({ items })
            });
            if (!response.ok) throw new Error('Cart error');
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            var drawer = document.querySelector('[data-cart-drawer], cart-drawer, #CartDrawer');
            if (drawer?.open) drawer.open();
            else if (typeof window.theme?.openCartDrawer === 'function') window.theme.openCartDrawer();
            else window.location.href = '/cart';
          }
        } catch (err) {
          console.error('[ctr-pbv2] Upsell cart add failed:', err);
        } finally {
          this.isAddingUpsell = false;
        }
      },

      /* ---- Mobile sticky observer ---- */
      init() {
        this._ensureInStockFlavors();
        this._ensureInStockUpsellFlavors();

        var self = this;
        this.$watch('selectedTier', function() { self.emitStickyAtcState(); });
        this.$watch('selectedFormat', function() { self.emitStickyAtcState(); });
        this.$watch('bagFlavors', function() { self.emitStickyAtcState(); });
        window.setTimeout(function() { self.emitStickyAtcState(); }, 0);

        if (
          !window.matchMedia('(max-width: 767px)').matches ||
          !('IntersectionObserver' in window) ||
          !this.$refs.primaryCta
        ) return;

        var observer = new IntersectionObserver(
          ([entry]) => { this.mobileStickyVisible = !entry.isIntersecting; },
          { threshold: 0.2 }
        );
        observer.observe(this.$refs.primaryCta);
      },

      _ensureInStockFlavors() {
        var firstAvailable = firstInStockFlavor(this.selectedFormat);
        this.bagFlavors = this.bagFlavors.map(function(f) {
          return flavorAvailable(this.selectedFormat, f) ? f : firstAvailable;
        }.bind(this));
      },

      _ensureInStockUpsellFlavors() {
        var self = this;
        var next = Object.assign({}, this.upsellFlavors);
        var changed = false;
        document.querySelectorAll('.ctr-pbv2__upsell[data-block-id]').forEach(function(el) {
          var blockId = el.getAttribute('data-block-id');
          if (!blockId) return;
          var current = next[blockId];
          if (current && self.isUpsellFlavorAvailable(blockId, current)) return;
          var first = self.firstInStockUpsellFlavor(blockId);
          if (first) {
            next[blockId] = first;
            changed = true;
          }
        });
        if (changed) this.upsellFlavors = next;
      }
    }));
  }

  window.ctrPbv2Factory = ctrPbv2Factory;

  /* Re-init any inert ctr-pbv2 sections.
     After a Barba (Smart theme) page transition, Alpine may walk the new
     section before this script has finished loading; the x-data expression
     fails (ctrPbv2Factory undefined) and the scope becomes empty {}. Detect
     that and replace the section with a clone so Alpine re-walks it fresh. */
  function rebootInertSections() {
    if (!window.Alpine) return;
    document.querySelectorAll('[x-data*="ctrPbv2Factory"]').forEach(function (sec) {
      var stack = sec._x_dataStack;
      var hasMethods = !!(stack && stack[0] && typeof stack[0].selectFormat === 'function');
      if (hasMethods) return;
      var m = sec.getAttribute('x-data').match(/'([^']+)'/);
      if (!m || !document.getElementById('ctr-pbv2-data-' + m[1])) return;
      try {
        var clone = sec.cloneNode(true);
        sec.parentNode.replaceChild(clone, sec);
        if (typeof window.Alpine.initTree === 'function') {
          window.Alpine.initTree(clone);
        }
      } catch (e) {
        console.error('[ctr-pbv2] reboot failed', e);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', rebootInertSections);
  } else {
    /* Defer one tick so Alpine has a chance to walk first */
    setTimeout(rebootInertSections, 0);
  }

  /* Also reboot after Barba transitions */
  document.addEventListener('barba:afterEnter', function () {
    setTimeout(rebootInertSections, 0);
  });
})();
